import React, {useEffect} from 'react';
import './Help.css';

export const Help = props => {

	useEffect(() => {
		document.title = `e-Kontrole | Pomoc`;
		return () => {
			document.title = `e-Kontrole`;
		}
	}, []);
	
	return (<div id='help'>
		<h2 className='text-center mb-5'>Pomoc w użytkowaniu aplikacji e-Kontrole</h2>
		<p className='h5 my-4'>Jeżeli potrzebujesz pomocy, skorzystaj z <span className='font-bold'>Instrukcji użytkownika aplikacji e-Kontrole.</span></p>
		<p className='h5 my-4'>Jeżeli nie znalazłeś odpowiedzi na interesujące Cię zagadnienia, skontaktuj się z nami za pośrednictwem adresu poczty elektronicznej: <a href='mailto:eKontrole@mfipr.gov.pl'>eKontrole@mfipr.gov.pl.</a></p>
		<p className='h5 mb-4'> Wsparcie w zakresie użytkowania aplikacji prowadzone jest również za pośrednictwem systemu SD2020 dostępnego pod adresem: <a target='_blank' href='https://sd.sl.gov.pl'>https://sd.sl.gov.pl.</a></p>
	</div>);
};


